






import { defineComponent, useContext } from '@nuxtjs/composition-api';
import { useSocialLogin } from '~/composables/auth/useSocialLogin';
import { url } from '~/utils';
import { sendLoginEvent as sendEvent } from '~/utils/ga';
import { SocialLoginProvider } from '~/enums';
import { LoginStatus, LoginCategory } from '~/enums/login';

const loginApple = require('~/assets/images/login/apple-id-sign-up-with_2x.png');

export default defineComponent({
  setup() {
    const { redirect } = useContext();
    const { getLoginUrl } = useSocialLogin();

    const onClickAppleButton = () => {
      sendEvent(LoginStatus.TRIED, LoginCategory.APPLE);
      localStorage.setItem('loginCategory', LoginCategory.APPLE);
      const appleUrl = getLoginUrl(SocialLoginProvider.APPLE, url('LOGIN_WITH_SOCIAL'));
      try {
        redirect(appleUrl);
      } catch {
        // 何もしない
      }
    };

    return {
      onClickAppleButton,
      loginApple,
    };
  },
});
